import { lazy } from 'react';

/* ══ AS SALAS BAIXADAS SOB DEMANDA (V1849 · 04/10/2026, pedido dele) ════════════════════════════════
   Ele: "um usuário que só tem acesso à Sala 1, mesmo não tendo acesso às demais salas, elas são baixadas".
   Medido na V1846: o build saía num arquivo só de 3,9 MB (1 MB comprimido), com as 43 salas dentro.

   Agora cada sala é um PEDAÇO próprio, baixado quando a pessoa entra nela — e, logo depois do login, o
   sistema PRÉ-BAIXA em segundo plano só as salas que ela tem acesso (a Sala 1 primeiro).

   ⚠⚠ O PRÉ-DOWNLOAD NÃO É ENFEITE, É O QUE SEGURA O OFFLINE DA EXPEDIÇÃO. O service worker guarda os
   arquivos à medida que são baixados (rede primeiro, cache de reserva). Com um arquivo só, abrir uma vez
   guardava tudo. Com pedaços, sem o pré-download: depois de um deploy, o celular abre na Home com rede,
   perde a rede e só então entra na Sala 1 — o pedaço NOVO dela não estaria guardado e a sala não abriria.
   (As filas e os rascunhos ficam no IndexedDB e o Background Sync do worker os envia sem precisar deste código — o que
   se protege aqui é a TELA da Sala 1, para a pessoa conseguir trabalhar sem rede.)

   ⚠ DEPOIS DE UM DEPLOY, COM REDE, o index antigo (ainda aberto) pode pedir um pedaço que não existe mais
   (o nome tem o hash da versão). Aí recarrega UMA vez, para pegar o index novo — a marca na sessão impede
   recarregar em laço. Sem rede, o erro sobe para o SalaSobDemanda, que explica em vez de tela branca. */
export const CARREGAR = {
  1: () => import('../pages/Sala1/Sala1'), 2: () => import('../pages/Sala2/Sala2.jsx'), 3: () => import('../pages/Sala3/Sala3'),
  4: () => import('../pages/Sala4/Sala4'), 5: () => import('../pages/Sala5/Sala5'), 6: () => import('../pages/Sala6/Sala6'),
  7: () => import('../pages/Sala7/Sala7'), 8: () => import('../pages/Sala8/Sala8'), 9: () => import('../pages/Sala9/Sala9'),
  10: () => import('../pages/Sala10/Sala10'), 11: () => import('../pages/Sala11/Sala11'), 12: () => import('../pages/Sala12/Sala12'),
  13: () => import('../pages/Sala13/Sala13'), 15: () => import('../pages/Sala15/Sala15'), 16: () => import('../pages/Sala16/Sala16'),
  17: () => import('../pages/Sala17/Sala17'), 18: () => import('../pages/Sala18/Sala18'), 19: () => import('../pages/Sala19/Sala19.jsx'),
  20: () => import('../pages/Sala20/Sala20.jsx'), 21: () => import('../pages/Sala21/Sala21.jsx'), 22: () => import('../pages/Sala22/Sala22.jsx'),
  23: () => import('../pages/Sala23/Sala23.jsx'), 24: () => import('../pages/Sala24/Sala24.jsx'), 25: () => import('../pages/Sala25/Sala25.jsx'),
  26: () => import('../pages/Sala26/Sala26.jsx'), 27: () => import('../pages/Sala27/Sala27.jsx'), 28: () => import('../pages/Sala28/Sala28.jsx'),
  29: () => import('../pages/Sala29/Sala29.jsx'), 30: () => import('../pages/Sala30/Sala30.jsx'), 31: () => import('../pages/Sala31/Sala31.jsx'),
  32: () => import('../pages/Sala32/Sala32.jsx'), 33: () => import('../pages/Sala33/Sala33.jsx'), 34: () => import('../pages/Sala34/Sala34.jsx'),
  35: () => import('../pages/Sala35/Sala35.jsx'), 36: () => import('../pages/Sala36/Sala36.jsx'), 37: () => import('../pages/Sala37/Sala37.jsx'),
  38: () => import('../pages/Sala38/Sala38.jsx'), 39: () => import('../pages/Sala39/Sala39.jsx'), 40: () => import('../pages/Sala40/Sala40.jsx'),
  41: () => import('../pages/Sala41/Sala41.jsx'), 42: () => import('../pages/Sala42/Sala42.jsx'), 43: () => import('../pages/Sala43/Sala43.jsx'),
  44: () => import('../pages/Sala44/Sala44.jsx'),
};

const MARCA = 'sgq_pedaco_recarregou';
const jaRecarregou = () => { try { return sessionStorage.getItem(MARCA) === '1'; } catch { return true; } };
/* o componente preguiçoso, com o recarregar-uma-vez depois de um deploy */
export function sobDemanda(carregar) {
  return lazy(() => carregar()
    .then(m => { try { sessionStorage.removeItem(MARCA); } catch (e) { console.debug('[sob demanda] sessão', e.message); } return m; })
    .catch(err => {
      if (navigator.onLine && !jaRecarregou()) {
        try { sessionStorage.setItem(MARCA, '1'); } catch (e) { console.debug('[sob demanda] sessão', e.message); }
        window.location.reload();
        return new Promise(() => {});   // a página vai recarregar — não renderiza nada até lá
      }
      throw err;
    }));
}
export const SALAS = Object.fromEntries(Object.entries(CARREGAR).map(([n, f]) => [n, sobDemanda(f)]));

/* O PRÉ-DOWNLOAD: as salas que a pessoa tem acesso, uma de cada vez, quando o navegador está folgado.
   Erro aqui é silencioso de propósito (é só adiantar trabalho) — a sala tenta de novo quando a pessoa entrar. */
let feito = false;
export function preBaixar(numeros) {
  if (feito || !numeros.length) return; feito = true;
  const fila = [...new Set(numeros.map(Number))].filter(n => CARREGAR[n]).sort((a, b) => (a === 1 ? -1 : b === 1 ? 1 : a - b));
  const folga = window.requestIdleCallback || ((f) => setTimeout(f, 300));
  const proximo = () => { const n = fila.shift(); if (n == null) return; CARREGAR[n]().catch(e => console.debug(`[pré-download] sala ${n}`, e.message)).finally(() => folga(proximo)); };
  proximo();   // a primeira (a Sala 1, quando a pessoa tem) começa NA HORA, sem esperar folga — é a que trabalha sem rede
}
